export const THEME = {
  navbar: { bgColor: '#1a1a27', color: '#80808F', icColor: '#ffffff' },
  sidebar: {
    shopNameColor: '#ffffff',
    icColor: '#b5b5c3',
    bgColor: '#1e1e2d',
    color: '#b5b5c3',
    focusBgColor: '#7ab8b6',
    focusColor: '#ffffff',
    hoverBgColor: '#242436',
    hoverColor: '#ffffff',
    subBgColor: '#000000',
    subColor: '#b5b5c3',
    subFocusBgColor: '#7ab8b6',
    subFocusColor: '#ffffff',
    subHoverBgColor: '#1e1e2d',
    subHoverColor: '#ffffff'
  },
  profile: {
    bgColor: '#1e1e2d',
    color: '#b5b5c3',
    expireBgColor: '#17b987',
    expireColor: '#000000',
    clearBgColor: '#E5EAEE',
    clearColor: '#464E5F',
    logoutBgColor: '#4A7DFF',
    logoutColor: '#ffffff',
    demoRoleColor: '#ffffff',
    notifyBgColor: '#d8d0ff',
    notifyColor: '#000000'
  },
  mainheader: { bgColor: '#ffffff', color: '#1a1a27', pointColor: '#15b7b3' },
  main: { bgColor: '#5E73B7', bg: '' },
  regis: {
    bgColor: '#5E73B7', bg: '',
    shopNameColor: '#15b7b3',
    labelColor: "#464E5F",
    placeholderColor: "#757575",
  },
  login: {
    line: {
      text: 'Sign in with Line',
      bgColor: '#06C755',
      color: '#ffffff',
      // icColor: '#ffffff'
    },
    mobile: {
      text: 'Sign in with Mobile',
      bgColor: '#32A881',
      color: '#ffffff',
    }
  },
  custom: {
    button: {
      primary: {
        bgColor: '#000000',
        color: '#ffffff',
        variant: 'contained',
      },
      secondary: {
        bgColor: '#000000',
        color: '#000000',
        variant: 'outlined',
      },
    },
    tab: {
      primary: {
        bgColor: '#6993ff',
        color: '#ffffff',
      },
      secondary: {
        bgColor: '#ffffff',
        color: '#1A1A27',
      },
    },
    card: { // special packages
      bgColor: '#7AB8B6',
      color: '#1A1A27',
      circle: {
        bgColor: '#000000',
        primaryColor: '#FFFFFF',
        secondaryColor: '#FFFF00'
      }
    },
    redeem: {
      text: '',
      bgColor: '#1976d2',
      color: '#1976d2',
      variant: 'outlined'
    },
    category: {
      allColor: '#ffffff',
      othersColor: '#FFE3E3B3',
      seemoreColor: '#ffffff',
    },
  }
};
